import script from "./collections.vue?vue&type=script&setup=true&lang=js"
export * from "./collections.vue?vue&type=script&setup=true&lang=js"

import "./collections.vue?vue&type=style&index=0&id=093b32a3&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-093b32a3"]])

export default __exports__